import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	sampleCta: {
		id: 'homepage.toolsSlide.sampleCta',
		defaultMessage: 'Free Sample',
		description: "Indication that the playabable content is a free sample of Calm's library",
	},
});
